var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.len),function(l){return _c('iframe',{attrs:{"src":_vm.src}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }